import Swal from 'sweetalert2';

const baseConfig = {
  confirmButtonText: 'OK',
  customClass: {
    confirmButton: 'swal2-confirm'
  }
};

export const showError = (message) => {
  return Swal.fire({
    icon: 'error',
    title: 'Error',
    text: message || 'Something went wrong.',
    ...baseConfig
  });
};

export const showSuccess = (message) => {
  return Swal.fire({
    icon: 'success',
    title: 'Success',
    text: message || '',
    ...baseConfig
  });
};

export const showWarning = (message) => {
  return Swal.fire({
    icon: 'warning',
    title: 'Warning',
    text: message || '',
    ...baseConfig
  });
};

export const showInfo = (message) => {
  return Swal.fire({
    icon: 'info',
    title: 'Info',
    text: message || '',
    ...baseConfig
  });
};

export const showConfirm = (options) => {
  return Swal.fire({
    icon: 'question',
    showCancelButton: true,
    confirmButtonText: 'Yes',
    cancelButtonText: 'No',
    ...baseConfig,
    ...options
  });
};
